import axios from "axios";
import { toast } from "sonner";
import { Check, X, Trash2 } from "lucide-react";
import { fmtDateTime } from "@/lib/format";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const STATUS_STYLE = { approved: "text-emerald-400", rejected: "text-red-400" };

export const AdminStoriesTab = ({ stories, setStories }) => {
  const updateStory = async (id, status) => {
    try {
      await axios.patch(`${API}/admin/stories/${id}`, { status });
      setStories((prev) => prev.map((s) => (s.id === id ? { ...s, status } : s)));
      toast.success(`Story ${status}.`);
    } catch {
      toast.error("Could not update story.");
    }
  };

  const deleteStory = async (id) => {
    if (!window.confirm("Delete this story permanently?")) return;
    try {
      await axios.delete(`${API}/admin/stories/${id}`);
      setStories((prev) => prev.filter((s) => s.id !== id));
      toast.success("Story deleted.");
    } catch {
      toast.error("Could not delete story.");
    }
  };

  return (
    <div className="space-y-4" data-testid="admin-stories-list">
      {stories.length === 0 && <div className="tacc-card p-8 text-center text-[#78716C]">No stories submitted yet.</div>}
      {stories.map((st) => (
        <div key={st.id} data-testid={`admin-story-${st.id}`} className="tacc-card p-6 md:p-8 flex flex-col md:flex-row md:items-start gap-6">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-3">
              <span className={`font-mono text-[10px] tracking-[0.25em] uppercase ${STATUS_STYLE[st.status] || "text-[#B45309]"}`}>{st.status}</span>
              <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#A8A29E]">{fmtDateTime(st.created_at)}</span>
              {st.source === "journal" && <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-[#78716C] border border-[#E7DFD5] px-2 py-0.5" data-testid={`story-source-journal-${st.id}`}>From a member's journal</span>}
            </div>
            <p className="font-display text-xl md:text-2xl leading-tight tracking-tight mb-3">{`“${st.quote}”`}</p>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#78716C]">
              — {[st.name, st.role].filter(Boolean).join(" · ")} · <span className="text-[#A8A29E] normal-case tracking-normal">{st.email}</span>
            </p>
          </div>
          <div className="flex md:flex-col gap-2 md:min-w-[140px]">
            {st.status !== "approved" && (
              <button onClick={() => updateStory(st.id, "approved")} data-testid={`story-approve-${st.id}`} className="btn-ember text-xs justify-center flex-1 md:flex-none"><Check size={14} /> Approve</button>
            )}
            {st.status !== "rejected" && (
              <button onClick={() => updateStory(st.id, "rejected")} data-testid={`story-reject-${st.id}`} className="btn-outline text-xs justify-center flex-1 md:flex-none"><X size={14} /> Reject</button>
            )}
            <button onClick={() => deleteStory(st.id)} data-testid={`story-delete-${st.id}`} className="btn-outline text-xs justify-center flex-1 md:flex-none border-red-400/40 text-red-400 hover:border-red-400"><Trash2 size={14} /> Delete</button>
          </div>
        </div>
      ))}
    </div>
  );
};
